module.exports = "/_next/static/images/instrument_4-38f34c9aa2fc39312e0702a56c7052fd.png";